import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { GrIcon } from "../icons";
import { palette } from "../../theme/palette";
import { typography } from "../../theme/typography";
import styled from "@emotion/styled";
import { Alert, Snackbar } from "@mui/material";
import classNames from "classnames";
import { GrButton } from "../buttons/GrButton";
import { GrIconButton } from "../buttons/GrIconButton";
const StyledSnackbar = styled(Snackbar, { shouldForwardProp: propsName => propsName !== "hasAction" })(({ severity, hasAction, type }) => {
    const [borderColor, backgroundColor] = (() => {
        switch (severity) {
            case "success":
                return ["green020", "positive-bg"];
            case "danger":
                return ["red020", "negative-bg"];
            case "warning":
                return ["orange020", "warning-bg"];
            case "info":
                return ["darkNavy020", "darkNavy010"];
            default:
                return ["green020", "positive-bg"];
        }
    })();
    return {
        borderRadius: "8px",
        border: `1px solid ${palette[borderColor]}`,
        background: palette[backgroundColor],
        boxShadow: "0px 2px 24px 0px rgba(0, 0, 0, 0.16)",
        width: "320px",
        ...(!!hasAction && {
            width: "auto",
            maxWidth: "400px",
        }),
        ".MuiPaper-root": {
            display: "flex",
            padding: "18px",
            justifyContent: "space-between",
            maxWidth: type === "basic" ? "284px" : "364px",
        },
        ".MuiAlert-icon": {
            minHeight: "24px",
            padding: "0px",
            margin: "0px 8px 0px 0px",
        },
        ".MuiAlert-message": {
            display: "flex",
            alignItems: "center",
            width: "100%",
            flexBasis: "100%",
            wordBreak: "break-all",
            padding: "0px",
            ...typography["Content.Subtitle03"],
            ...(!!hasAction && {
                width: "auto",
                maxWidth: "292px",
            }),
        },
        ".MuiAlert-action": {
            marginRight: 0,
            marginLeft: "16px",
            padding: "0px",
            alignItems: "center",
            ".GrIconButton": {
                width: "14px",
                height: "14px",
            },
            button: {
                justifyContent: "flex-end",
                minWidth: "unset",
                width: "max-content",
            },
        },
    };
});
export function GrSnackbar(props) {
    var _a, _b, _c, _d, _e;
    const severity = props.severity === "danger" ? "error" : props.severity;
    const getIcon = (severity) => {
        switch (severity) {
            case "success":
                return (_jsx(GrIcon, { type: "circle-check-filled", size: 18, color: "positive-primary", style: { display: "flex", width: "25px", height: "25px", justifyContent: "center", alignItems: "center" } }));
            case "danger":
                return (_jsx(GrIcon, { type: "alert-hexagon-filled", size: 18, color: "negative-primary", style: { display: "flex", width: "25px", height: "25px", justifyContent: "center", alignItems: "center" } }));
            case "warning":
                return (_jsx(GrIcon, { type: "alert-triangle-filled", size: 18, color: "warning-primary", style: { display: "flex", width: "25px", height: "25px", justifyContent: "center", alignItems: "center" } }));
            case "info":
                return (_jsx(GrIcon, { type: "info", size: 18, color: "darkNavy040", style: { display: "flex", width: "25px", height: "25px", justifyContent: "center", alignItems: "center" } }));
            default: // success
                return (_jsx(GrIcon, { type: "circle-check-filled", size: 18, color: "positive-primary", style: { display: "flex", width: "25px", height: "25px", justifyContent: "center", alignItems: "center" } }));
        }
    };
    const getSnackbarOrigin = (type) => {
        switch (type) {
            case "basic":
                return { vertical: "top", horizontal: "right" };
            case "action":
                return { vertical: "bottom", horizontal: "center" };
            default: // basic
                return { vertical: "top", horizontal: "right" };
        }
    };
    const action = (() => {
        var _a;
        if (props.action && typeof props.action === "object") {
            if ("text" in props.action) {
                return (_jsx(GrButton, { variant: "text", onClick: props.action.onClick, style: {
                        padding: 0,
                        height: "20px",
                    }, color: (props.severity === "success" && "green") ||
                        (props.severity === "danger" && "red") ||
                        (props.severity === "warning" && "orange") ||
                        (props.severity === "info" && "primary") ||
                        "green", children: props.action.text }));
            }
            if ("icon" in props.action) {
                return (_jsx(GrIconButton, { iconType: props.action.icon || "x-mark", size: 14, style: { padding: 0, margin: 0, display: "flex", alignItems: "center", justifyContent: "center", height: 25, width: 25 }, onClick: (_a = props.action) === null || _a === void 0 ? void 0 : _a.onClick }));
            }
            if ("onClick" in props.action) {
                return (_jsx(GrIconButton, { iconType: "x-mark", size: 14, style: { padding: 0, margin: 0, display: "flex", alignItems: "center", justifyContent: "center", height: 25, width: 25 }, onClick: props.action.onClick }));
            }
            return props.action;
        }
        return undefined;
    })();
    return (_jsx(StyledSnackbar, { className: classNames("GrSnackbar", props.className), open: props.open, autoHideDuration: (_a = props.autoHideDuration) !== null && _a !== void 0 ? _a : 5000, onClose: props.onClose, anchorOrigin: {
            vertical: (_c = (_b = props.anchorOrigin) === null || _b === void 0 ? void 0 : _b.vertical) !== null && _c !== void 0 ? _c : getSnackbarOrigin(props.type).vertical,
            horizontal: (_e = (_d = props.anchorOrigin) === null || _d === void 0 ? void 0 : _d.horizontal) !== null && _e !== void 0 ? _e : getSnackbarOrigin(props.type).horizontal,
        }, style: props.style, severity: props.severity, hasAction: !!props.action, type: props.type, children: _jsx(Alert, { icon: getIcon(props.severity), onClose: props.onClose, severity: severity, variant: "standard", sx: { width: props.type === "basic" ? "300px" : "400px", borderRadius: "inherit" }, action: action, children: props.message }) }));
}
//# sourceMappingURL=GrSnackbar.js.map